import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class NetworkView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      network: this.props.network
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state.network);
  };

  handleCancel = e => {
    e.preventDefault();
    this.props.onCancel();
  };

  handleInputChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let network = { ...this.state.network, [name]: value };
    this.setState({ network });
  };

  render() {
    return (
      <div className="w3-card-4">
        <div className="w3-container w3-theme">
          <h2 className="w3-center">{this.props.title}</h2>
        </div>

        <form className="w3-container" onSubmit={this.handleSubmit}>
          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="name"
                onChange={this.handleInputChange}
                value={this.state.network.name}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="network.name" defaultMessage="Name" />
              </label>
            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="text"
                name="description"
                onChange={this.handleInputChange}
                value={this.state.network.description}
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage
                  id="network.description"
                  defaultMessage="Description"
                />
              </label>
            </div>
          </div>

          <div className="w3-bar">
            <button
              className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
              type="submit"
            >
              {this.props.sumbitText}
            </button>
            <button
              className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
              type="reset"
              onClick={this.handleCancel}
            >
              {this.props.cancelText}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

NetworkView.propTypes = {
  title: PropTypes.string.isRequired,
  network: PropTypes.object.isRequired,
  cancelText: PropTypes.string.isRequired,
  sumbitText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default NetworkView;
